"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOidc = createOidc;
exports.createOidc_nonMemoized = createOidc_nonMemoized;
var oidc_client_ts_and_jwt_decode_1 = require("../vendor/frontend/oidc-client-ts-and-jwt-decode");
var tsafe_1 = require("../vendor/frontend/tsafe");
var workerTimers_1 = require("../tools/workerTimers");
var Deferred_1 = require("../tools/Deferred");
var decodeJwt_1 = require("../tools/decodeJwt");
var isUserActive_1 = require("./isUserActive");
var startCountdown_1 = require("../tools/startCountdown");
var toHumanReadableDuration_1 = require("../tools/toHumanReadableDuration");
var toFullyQualifiedUrl_1 = require("../tools/toFullyQualifiedUrl");
var OidcInitializationError_1 = require("./OidcInitializationError");
var StateData_1 = require("./StateData");
var logoutPropagationToOtherTabs_1 = require("./logoutPropagationToOtherTabs");
var configId_1 = require("./configId");
var oidcClientTsUserToTokens_1 = require("./oidcClientTsUserToTokens");
var loginSilent_1 = require("./loginSilent");
var handleOidcCallback_1 = require("./handleOidcCallback");
var persistedAuthState_1 = require("./persistedAuthState");
var AwaitableEventEmitter_1 = require("../tools/AwaitableEventEmitter");
var haveSharedParentDomain_1 = require("../tools/haveSharedParentDomain");
var loginOrGoToAuthServer_1 = require("./loginOrGoToAuthServer");
var ephemeralSessionStorage_1 = require("../tools/ephemeralSessionStorage");
// NOTE: Replaced at build time
var VERSION = "6.5.2";
(0, handleOidcCallback_1.handleOidcCallback)();
var GLOBAL_CONTEXT_KEY = "__oidc-spa.createOidc.globalContext";
(_a = window[GLOBAL_CONTEXT_KEY]) !== null && _a !== void 0 ? _a : (window[GLOBAL_CONTEXT_KEY] = {
    prOidcByConfigId: new Map(),
    evtAuthResponseHandled: (0, AwaitableEventEmitter_1.createAwaitableEventEmitter)(),
    $isUserActive: undefined,
    hasLogoutBeenCalled: false
});
var globalContext = window[GLOBAL_CONTEXT_KEY];
var MIN_RENEW_BEFORE_EXPIRE_MS = 2000;
/** @see: https://docs.oidc-spa.dev/v/v6/usage */
function createOidc(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, name_1, value, issuerUri_params, clientId, _c, scopes, debugLogs, rest, issuerUri, log, configId, prOidcByConfigId, prOidc, dOidc, oidc;
        var e_1, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    try {
                        for (_a = __values(["issuerUri", "clientId"]), _b = _a.next(); !_b.done; _b = _a.next()) {
                            name_1 = _b.value;
                            value = params[name_1];
                            if (!value) {
                                throw new Error("The parameter \"".concat(name_1, "\" is required, you provided: ").concat(value, ". (Forgot a .env variable?)"));
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    issuerUri_params = params.issuerUri, clientId = params.clientId, _c = params.scopes, scopes = _c === void 0 ? ["profile"] : _c, debugLogs = params.debugLogs, rest = __rest(params, ["issuerUri", "clientId", "scopes", "debugLogs"]);
                    issuerUri = (0, toFullyQualifiedUrl_1.toFullyQualifiedUrl)({
                        urlish: issuerUri_params,
                        doAssertNoQueryParams: true,
                        doOutputWithTrailingSlash: false
                    });
                    log = (function () {
                        if (!debugLogs) {
                            return undefined;
                        }
                        return (0, tsafe_1.id)(function () {
                            var _a = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                _a[_i] = arguments[_i];
                            }
                            var _b = __read(_a), first = _b[0], rest = _b.slice(1);
                            var label = "oidc-spa";
                            if (typeof first === "string") {
                                console.log.apply(console, __spreadArray([], __read(__spreadArray(["".concat(label, ": ").concat(first)], __read(rest), false)), false));
                            }
                            else {
                                console.log.apply(console, __spreadArray([], __read(__spreadArray(["".concat(label, ":"), first], __read(rest), false)), false));
                            }
                        });
                    })();
                    configId = (0, configId_1.getConfigId)({ issuerUri: issuerUri, clientId: clientId });
                    prOidcByConfigId = globalContext.prOidcByConfigId;
                    use_previous_instance: {
                        prOidc = prOidcByConfigId.get(configId);
                        if (prOidc === undefined) {
                            break use_previous_instance;
                        }
                        log === null || log === void 0 ? void 0 : log([
                            "createOidc was called again with the same config (".concat(JSON.stringify({
                                issuerUri: issuerUri,
                                clientId: clientId
                            }), ")"),
                            "Returning the previous instance. All potential different parameters are ignored."
                        ].join(" "));
                        // @ts-expect-error: We know what we're doing
                        return [2 /*return*/, prOidc];
                    }
                    dOidc = new Deferred_1.Deferred();
                    prOidcByConfigId.set(configId, dOidc.pr);
                    return [4 /*yield*/, createOidc_nonMemoized(rest, {
                            issuerUri: issuerUri,
                            clientId: clientId,
                            scopes: scopes,
                            configId: configId,
                            log: log
                        })];
                case 1:
                    oidc = _e.sent();
                    dOidc.resolve(oidc);
                    return [2 /*return*/, oidc];
            }
        });
    });
}
function createOidc_nonMemoized(params, preProcessedParams) {
    return __awaiter(this, void 0, void 0, function () {
        var transformUrlBeforeRedirect, extraQueryParamsOrGetter, extraTokenParamsOrGetter, homeUrl_params, decodedIdTokenSchema, __unsafe_ssoSessionIdleSeconds, _a, autoLogoutParams, _b, autoLogin, postLoginRedirectUrl_default, __unsafe_clientSecret, _c, __unsafe_useIdTokenAsAccessToken, issuerUri, clientId, scopes, configId, log, _d, getExtraQueryParams, getExtraTokenParams, homeAndCallbackUrl, isHandled, stateQueryParamValue_instance, areThirdPartyCookiesAllowed, url1, url2, isUserStorePersistent, oidcClientTsUserManager, _e, loginOrGoToAuthServer, toCallBeforeReturningOidcLoggedIn, toCallBeforeReturningOidcNotLoggedIn, BROWSER_SESSION_NOT_FIRST_INIT_KEY, resultOfLoginProcess, common, oidc_notLoggedIn, currentTokens, autoLogoutCountdownTickCallbacks, onTokenChanges, oidc_loggedIn, sessionId, prOtherTabLogout, startCountdown_2, stopCountdown_1;
        var _this = this;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    transformUrlBeforeRedirect = params.transformUrlBeforeRedirect, extraQueryParamsOrGetter = params.extraQueryParams, extraTokenParamsOrGetter = params.extraTokenParams, homeUrl_params = params.homeUrl, decodedIdTokenSchema = params.decodedIdTokenSchema, __unsafe_ssoSessionIdleSeconds = params.__unsafe_ssoSessionIdleSeconds, _a = params.autoLogoutParams, autoLogoutParams = _a === void 0 ? { redirectTo: "current page" } : _a, _b = params.autoLogin, autoLogin = _b === void 0 ? false : _b, postLoginRedirectUrl_default = params.postLoginRedirectUrl, __unsafe_clientSecret = params.__unsafe_clientSecret, _c = params.__unsafe_useIdTokenAsAccessToken, __unsafe_useIdTokenAsAccessToken = _c === void 0 ? false : _c;
                    issuerUri = preProcessedParams.issuerUri, clientId = preProcessedParams.clientId, scopes = preProcessedParams.scopes, configId = preProcessedParams.configId, log = preProcessedParams.log;
                    _d = __read([extraQueryParamsOrGetter, extraTokenParamsOrGetter].map(function (valueOrGetter) {
                        if (typeof valueOrGetter === "function") {
                            return valueOrGetter;
                        }
                        if (valueOrGetter !== undefined) {
                            return function () { return valueOrGetter; };
                        }
                        return undefined;
                    }), 2), getExtraQueryParams = _d[0], getExtraTokenParams = _d[1];
                    homeAndCallbackUrl = (0, toFullyQualifiedUrl_1.toFullyQualifiedUrl)({
                        urlish: homeUrl_params,
                        doAssertNoQueryParams: true,
                        doOutputWithTrailingSlash: true
                    });
                    log === null || log === void 0 ? void 0 : log("Calling createOidc v".concat(VERSION), {
                        issuerUri: issuerUri,
                        clientId: clientId,
                        scopes: scopes,
                        configId: configId,
                        homeAndCallbackUrl: homeAndCallbackUrl
                    });
                    isHandled = (0, handleOidcCallback_1.handleOidcCallback)().isHandled;
                    if (!isHandled) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function () { })];
                case 1:
                    _f.sent();
                    _f.label = 2;
                case 2:
                    stateQueryParamValue_instance = (0, StateData_1.generateStateQueryParamValue)();
                    {
                        url1 = window.location.origin;
                        url2 = issuerUri;
                        areThirdPartyCookiesAllowed = (0, haveSharedParentDomain_1.getHaveSharedParentDomain)({
                            url1: url1,
                            url2: url2
                        });
                        if (areThirdPartyCookiesAllowed) {
                            log === null || log === void 0 ? void 0 : log("".concat(url1, " and ").concat(url2, " have shared parent domain, third party cookies are allowed"));
                        }
                        else {
                            log === null || log === void 0 ? void 0 : log([
                                "".concat(url1, " and ").concat(url2, " don't have shared parent domain, setting third party cookies"),
                                "on the auth server domain might not work. Making sure that everything works smoothly regardless",
                                "by allowing oidc-spa to store the auth state in the session storage for a limited period of time."
                            ].join(" "));
                        }
                    }
                    isUserStorePersistent = !areThirdPartyCookiesAllowed;
                    oidcClientTsUserManager = new oidc_client_ts_and_jwt_decode_1.UserManager({
                        stateQueryParamValue: stateQueryParamValue_instance,
                        authority: issuerUri,
                        client_id: clientId,
                        redirect_uri: homeAndCallbackUrl,
                        silent_redirect_uri: homeAndCallbackUrl,
                        post_logout_redirect_uri: homeAndCallbackUrl,
                        response_type: "code",
                        scope: Array.from(new Set(__spreadArray(["openid"], __read(scopes), false))).join(" "),
                        automaticSilentRenew: false,
                        userStore: new oidc_client_ts_and_jwt_decode_1.WebStorageStateStore({
                            store: areThirdPartyCookiesAllowed
                                ? new oidc_client_ts_and_jwt_decode_1.InMemoryWebStorage()
                                : (0, ephemeralSessionStorage_1.createEphemeralSessionStorage)({
                                    sessionStorageTtlMs: 3 * 601000
                                })
                        }),
                        stateStore: new oidc_client_ts_and_jwt_decode_1.WebStorageStateStore({ store: localStorage, prefix: StateData_1.STATE_STORE_KEY_PREFIX }),
                        client_secret: __unsafe_clientSecret
                    });
                    _e = (0, loginOrGoToAuthServer_1.createLoginOrGoToAuthServer)({
                        configId: configId,
                        oidcClientTsUserManager: oidcClientTsUserManager,
                        getExtraQueryParams: getExtraQueryParams,
                        transformUrlBeforeRedirect: transformUrlBeforeRedirect,
                        homeAndCallbackUrl: homeAndCallbackUrl,
                        log: log
                    }), loginOrGoToAuthServer = _e.loginOrGoToAuthServer, toCallBeforeReturningOidcLoggedIn = _e.toCallBeforeReturningOidcLoggedIn, toCallBeforeReturningOidcNotLoggedIn = _e.toCallBeforeReturningOidcNotLoggedIn;
                    BROWSER_SESSION_NOT_FIRST_INIT_KEY = "oidc-spa.browser-session-not-first-init:".concat(configId);
                    return [4 /*yield*/, (function () { return __awaiter(_this, void 0, void 0, function () {
                            var authResponse, stateData, evtAuthResponseHandled_1, prHandled, _a, authResponseUrl, oidcClientTsUser, error_1, error_3, authResponseUrl, _b, oidcClientTsUser, _c, _d, persistedAuthState, result_loginSilent, authResponse, authResponse_error, oidcClientTsUser, error_2;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        authResponse = (function () {
                                            var value = sessionStorage.getItem(handleOidcCallback_1.AUTH_RESPONSE_KEY);
                                            if (value === null) {
                                                return undefined;
                                            }
                                            var authResponse;
                                            try {
                                                authResponse = JSON.parse(value);
                                                (0, tsafe_1.assert)((0, tsafe_1.typeGuard)(authResponse, authResponse instanceof Object &&
                                                    Object.values(authResponse).every(function (value) { return typeof value === "string"; })), "Valid json but not expected shape");
                                            }
                                            catch (error) {
                                                console.error("Failed to parse auth response from callback URL ".concat(String(error)));
                                                return undefined;
                                            }
                                            return authResponse;
                                        })();
                                        if (authResponse === undefined) {
                                            return [3 /*break*/, 15];
                                        }
                                        stateData = (0, StateData_1.getStateData)({ stateQueryParamValue: authResponse["state"] });
                                        (0, tsafe_1.assert)(stateData !== undefined);
                                        (0, tsafe_1.assert)(stateData.context === "redirect");
                                        evtAuthResponseHandled_1 = globalContext.evtAuthResponseHandled;
                                        if (!(stateData.configId !== configId)) return [3 /*break*/, 4];
                                        prHandled = evtAuthResponseHandled_1.waitFor();
                                        return [4 /*yield*/, Promise.resolve()];
                                    case 1:
                                        _e.sent();
                                        if (!(sessionStorage.getItem(handleOidcCallback_1.AUTH_RESPONSE_KEY) === null)) return [3 /*break*/, 3];
                                        return [4 /*yield*/, prHandled];
                                    case 2:
                                        _e.sent();
                                        _e.label = 3;
                                    case 3: return [3 /*break*/, 15];
                                    case 4:
                                        sessionStorage.removeItem(handleOidcCallback_1.AUTH_RESPONSE_KEY);
                                        _a = stateData.action;
                                        switch (_a) {
                                            case "login": return [3 /*break*/, 5];
                                            case "logout": return [3 /*break*/, 10];
                                        }
                                        return [3 /*break*/, 15];
                                    case 5:
                                        log === null || log === void 0 ? void 0 : log("Handling login redirect auth response", authResponse);
                                        authResponseUrl = (0, loginSilent_1.authResponseToUrl)(authResponse);
                                        oidcClientTsUser = undefined;
                                        _e.label = 6;
                                    case 6:
                                        _e.trys.push([6, 8, , 9]);
                                        return [4 /*yield*/, oidcClientTsUserManager
                                                .signinRedirectCallback(authResponseUrl)
                                                .finally(function () {
                                                evtAuthResponseHandled_1.post();
                                            })];
                                    case 7:
                                        oidcClientTsUser = _e.sent();
                                        return [3 /*break*/, 9];
                                    case 8:
                                        error_1 = _e.sent();
                                        (0, tsafe_1.assert)(error_1 instanceof Error);
                                        if (error_1.message === "Failed to fetch") {
                                            return [2 /*return*/, (0, OidcInitializationError_1.createFailedToFetchTokenEndpointInitializationError)({
                                                    clientId: clientId,
                                                    issuerUri: issuerUri
                                                })];
                                        }
                                        {
                                            error_3 = authResponse["error"];
                                            if (error_3 !== undefined) {
                                                log === null || log === void 0 ? void 0 : log("The auth server responded with: ".concat(error_3, ", trying to restore from the http only cookie"));
                                                return [3 /*break*/, 15];
                                            }
                                        }
                                        return [2 /*return*/, error_1];
                                    case 9:
                                        sessionStorage.removeItem(BROWSER_SESSION_NOT_FIRST_INIT_KEY);
                                        return [2 /*return*/, {
                                                oidcClientTsUser: oidcClientTsUser,
                                                backFromAuthServer: {
                                                    extraQueryParams: stateData.extraQueryParams,
                                                    result: Object.fromEntries(Object.entries(authResponse).filter(function (_a) {
                                                        var _b = __read(_a, 1), name = _b[0];
                                                        return name !== "state" &&
                                                            name !== "session_state" &&
                                                            name !== "iss" &&
                                                            name !== "code";
                                                    }))
                                                }
                                            }];
                                    case 10:
                                        log === null || log === void 0 ? void 0 : log("Handling logout redirect auth response", authResponse);
                                        authResponseUrl = (0, loginSilent_1.authResponseToUrl)(authResponse);
                                        _e.label = 11;
                                    case 11:
                                        _e.trys.push([11, 13, , 14]);
                                        return [4 /*yield*/, oidcClientTsUserManager.signoutRedirectCallback(authResponseUrl)];
                                    case 12:
                                        _e.sent();
                                        return [3 /*break*/, 14];
                                    case 13:
                                        _b = _e.sent();
                                        return [3 /*break*/, 14];
                                    case 14:
                                        evtAuthResponseHandled_1.post();
                                        (0, logoutPropagationToOtherTabs_1.notifyOtherTabsOfLogout)({
                                            configId: configId,
                                            redirectUrl: stateData.redirectUrl,
                                            sessionId: stateData.sessionId
                                        });
                                        // NOTE: The user is no longer logged in.
                                        return [2 /*return*/, undefined];
                                    case 15:
                                        if (!isUserStorePersistent) {
                                            return [3 /*break*/, 24];
                                        }
                                        oidcClientTsUser = void 0;
                                        _e.label = 16;
                                    case 16:
                                        _e.trys.push([16, 18, , 23]);
                                        return [4 /*yield*/, oidcClientTsUserManager.getUser()];
                                    case 17:
                                        oidcClientTsUser = _e.sent();
                                        return [3 /*break*/, 23];
                                    case 18:
                                        _c = _e.sent();
                                        // NOTE: Not sure if it can throw, but let's be safe.
                                        oidcClientTsUser = null;
                                        _e.label = 19;
                                    case 19:
                                        _e.trys.push([19, 21, , 22]);
                                        return [4 /*yield*/, oidcClientTsUserManager.removeUser()];
                                    case 20:
                                        _e.sent();
                                        return [3 /*break*/, 22];
                                    case 21:
                                        _d = _e.sent();
                                        return [3 /*break*/, 22];
                                    case 22: return [3 /*break*/, 23];
                                    case 23:
                                        if (oidcClientTsUser === null) {
                                            return [3 /*break*/, 24];
                                        }
                                        log === null || log === void 0 ? void 0 : log("Restored the auth from ephemeral session storage");
                                        return [2 /*return*/, {
                                                oidcClientTsUser: oidcClientTsUser,
                                                backFromAuthServer: undefined
                                            }];
                                    case 24:
                                        log === null || log === void 0 ? void 0 : log("Trying to restore the auth from the http only cookie (silent signin with iframe)");
                                        persistedAuthState = (0, persistedAuthState_1.getPersistedAuthState)({ configId: configId });
                                        if (persistedAuthState === "explicitly logged out") {
                                            log === null || log === void 0 ? void 0 : log("Skipping silent signin with iframe, the user has logged out");
                                            return [3 /*break*/, 33];
                                        }
                                        return [4 /*yield*/, (0, loginSilent_1.loginSilent)({
                                                oidcClientTsUserManager: oidcClientTsUserManager,
                                                stateQueryParamValue_instance: stateQueryParamValue_instance,
                                                configId: configId,
                                                getExtraTokenParams: getExtraTokenParams
                                            })];
                                    case 25:
                                        result_loginSilent = _e.sent();
                                        (0, tsafe_1.assert)(result_loginSilent.outcome !== "token refreshed using refresh token");
                                        if (result_loginSilent.outcome === "failure") {
                                            switch (result_loginSilent.cause) {
                                                case "can't reach well-known oidc endpoint":
                                                    return [2 /*return*/, (0, OidcInitializationError_1.createWellKnownOidcConfigurationEndpointUnreachableInitializationError)({
                                                            issuerUri: issuerUri
                                                        })];
                                                case "timeout":
                                                    return [2 /*return*/, (0, OidcInitializationError_1.createIframeTimeoutInitializationError)({
                                                            homeAndCallbackUrl: homeAndCallbackUrl,
                                                            clientId: clientId,
                                                            issuerUri: issuerUri
                                                        })];
                                            }
                                            (0, tsafe_1.assert)(false);
                                        }
                                        (0, tsafe_1.assert)();
                                        authResponse = result_loginSilent.authResponse;
                                        log === null || log === void 0 ? void 0 : log("Silent signin auth response", authResponse);
                                        authResponse_error = authResponse["error"];
                                        oidcClientTsUser = undefined;
                                        _e.label = 26;
                                    case 26:
                                        _e.trys.push([26, 28, , 29]);
                                        return [4 /*yield*/, oidcClientTsUserManager.signinRedirectCallback((0, loginSilent_1.authResponseToUrl)(authResponse))];
                                    case 27:
                                        oidcClientTsUser = _e.sent();
                                        return [3 /*break*/, 29];
                                    case 28:
                                        error_2 = _e.sent();
                                        (0, tsafe_1.assert)(error_2 instanceof Error);
                                        if (error_2.message === "Failed to fetch") {
                                            return [2 /*return*/, (0, OidcInitializationError_1.createFailedToFetchTokenEndpointInitializationError)({
                                                    clientId: clientId,
                                                    issuerUri: issuerUri
                                                })];
                                        }
                                        if (authResponse_error === undefined) {
                                            return [2 /*return*/, error_2];
                                        }
                                        return [3 /*break*/, 29];
                                    case 29:
                                        if (!(oidcClientTsUser === undefined)) return [3 /*break*/, 32];
                                        if (!(autoLogin ||
                                            (persistedAuthState === "logged in" &&
                                                (authResponse_error === "interaction_required" ||
                                                    authResponse_error === "login_required" ||
                                                    authResponse_error === "consent_required" ||
                                                    authResponse_error === "account_selection_required")))) return [3 /*break*/, 31];
                                        (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: undefined });
                                        return [4 /*yield*/, loginOrGoToAuthServer({
                                                action: "login",
                                                doForceReloadOnBfCache: true,
                                                redirectUrl: window.location.href,
                                                doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack: autoLogin,
                                                extraQueryParams_local: undefined,
                                                transformUrlBeforeRedirect_local: undefined,
                                                doForceInteraction: false
                                            })];
                                    case 30:
                                        _e.sent();
                                        _e.label = 31;
                                    case 31:
                                        log === null || log === void 0 ? void 0 : log([
                                            "The auth server responded with: ".concat(authResponse_error, " "),
                                            "login_required" === authResponse_error
                                                ? "(login_required just means that there's no active session for the user)"
                                                : ""
                                        ].join(""));
                                        return [3 /*break*/, 33];
                                    case 32:
                                        log === null || log === void 0 ? void 0 : log("Successful silent signed in");
                                        return [2 /*return*/, {
                                                oidcClientTsUser: oidcClientTsUser,
                                                backFromAuthServer: undefined
                                            }];
                                    case 33: 
                                    // NOTE: The user is not logged in.
                                    return [2 /*return*/, undefined];
                                }
                            });
                        }); })().then(function (result) {
                            if (result === undefined) {
                                return undefined;
                            }
                            if (result instanceof Error) {
                                return result;
                            }
                            var oidcClientTsUser = result.oidcClientTsUser, backFromAuthServer = result.backFromAuthServer;
                            log_real_decoded_id_token: {
                                if (log === undefined) {
                                    break log_real_decoded_id_token;
                                }
                                var idToken = oidcClientTsUser.id_token;
                                if (idToken === undefined) {
                                    break log_real_decoded_id_token;
                                }
                                var decodedIdToken = (0, decodeJwt_1.decodeJwt)(idToken);
                                log([
                                    "Decoded ID token",
                                    decodedIdTokenSchema === undefined ? "" : " before `decodedIdTokenSchema.parse()`\n",
                                    JSON.stringify(decodedIdToken, null, 2)
                                ].join(""));
                                if (decodedIdTokenSchema === undefined) {
                                    break log_real_decoded_id_token;
                                }
                                log([
                                    "Decoded ID token after `decodedIdTokenSchema.parse()`\n",
                                    JSON.stringify(decodedIdTokenSchema.parse(decodedIdToken), null, 2)
                                ].join(""));
                            }
                            var tokens = (0, oidcClientTsUserToTokens_1.oidcClientTsUserToTokens)({
                                oidcClientTsUser: oidcClientTsUser,
                                decodedIdTokenSchema: decodedIdTokenSchema,
                                __unsafe_useIdTokenAsAccessToken: __unsafe_useIdTokenAsAccessToken,
                                decodedIdToken_previous: undefined,
                                log: log
                            });
                            if (tokens.refreshTokenExpirationTime < tokens.accessTokenExpirationTime) {
                                console.warn([
                                    "The OIDC refresh token shorter than the one of the access token.",
                                    "This is very unusual and probably a misconfiguration.",
                                    "Check your oidc server configuration for ".concat(clientId, " ").concat(issuerUri)
                                ].join(" "));
                            }
                            return { tokens: tokens, backFromAuthServer: backFromAuthServer };
                        })];
                case 3:
                    resultOfLoginProcess = _f.sent();
                    common = {
                        params: {
                            issuerUri: issuerUri,
                            clientId: clientId
                        }
                    };
                    not_loggedIn_case: {
                        if (!(resultOfLoginProcess instanceof Error) && resultOfLoginProcess !== undefined) {
                            break not_loggedIn_case;
                        }
                        oidc_notLoggedIn = (function () {
                            if (resultOfLoginProcess instanceof Error) {
                                log === null || log === void 0 ? void 0 : log("User not logged in and there was an initialization error");
                                var error = resultOfLoginProcess;
                                var initializationError = error instanceof OidcInitializationError_1.OidcInitializationError
                                    ? error
                                    : new OidcInitializationError_1.OidcInitializationError({
                                        isAuthServerLikelyDown: false,
                                        messageOrCause: error
                                    });
                                if (autoLogin) {
                                    throw initializationError;
                                }
                                console.error([
                                    "oidc-spa Initialization Error: ",
                                    "isAuthServerLikelyDown: ".concat(initializationError.isAuthServerLikelyDown),
                                    "",
                                    initializationError.message
                                ].join("\n"));
                                return (0, tsafe_1.id)(__assign(__assign({}, common), { isUserLoggedIn: false, login: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            alert("Authentication is currently unavailable. Please try again later.");
                                            return [2 /*return*/, new Promise(function () { })];
                                        });
                                    }); }, initializationError: initializationError }));
                            }
                            if (resultOfLoginProcess === undefined) {
                                log === null || log === void 0 ? void 0 : log("User not logged in");
                                return (0, tsafe_1.id)(__assign(__assign({}, common), { isUserLoggedIn: false, login: function (_a) {
                                        var _b;
                                        var doesCurrentHrefRequiresAuth = _a.doesCurrentHrefRequiresAuth, extraQueryParams = _a.extraQueryParams, redirectUrl = _a.redirectUrl, transformUrlBeforeRedirect = _a.transformUrlBeforeRedirect;
                                        return loginOrGoToAuthServer({
                                            action: "login",
                                            doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack: doesCurrentHrefRequiresAuth,
                                            doForceReloadOnBfCache: false,
                                            redirectUrl: (_b = redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : postLoginRedirectUrl_default) !== null && _b !== void 0 ? _b : window.location.href,
                                            extraQueryParams_local: extraQueryParams,
                                            transformUrlBeforeRedirect_local: transformUrlBeforeRedirect,
                                            doForceInteraction: (0, persistedAuthState_1.getPersistedAuthState)({ configId: configId }) === "explicitly logged out"
                                        });
                                    }, initializationError: undefined }));
                            }
                            (0, tsafe_1.assert)(false);
                        })();
                        if ((0, persistedAuthState_1.getPersistedAuthState)({ configId: configId }) !== "explicitly logged out") {
                            (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: undefined });
                        }
                        toCallBeforeReturningOidcNotLoggedIn();
                        // @ts-expect-error: We know what we're doing
                        return [2 /*return*/, oidc_notLoggedIn];
                    }
                    log === null || log === void 0 ? void 0 : log("User is logged in");
                    currentTokens = resultOfLoginProcess.tokens;
                    autoLogoutCountdownTickCallbacks = new Set();
                    onTokenChanges = new Set();
                    oidc_loggedIn = (0, tsafe_1.id)(__assign(__assign({}, common), { isUserLoggedIn: true, getTokens: function () { return currentTokens; }, getTokens_next: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!((0, oidcClientTsUserToTokens_1.getMsBeforeExpiration)(currentTokens) <= MIN_RENEW_BEFORE_EXPIRE_MS)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, oidc_loggedIn.renewTokens()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, currentTokens];
                                }
                            });
                        }); }, getDecodedIdToken: function () { return currentTokens.decodedIdToken; }, logout: function (params) { return __awaiter(_this, void 0, void 0, function () {
                            var postLogoutRedirectUrl, error_4, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (globalContext.hasLogoutBeenCalled) {
                                            log === null || log === void 0 ? void 0 : log("logout() has already been called, ignoring the call");
                                            return [2 /*return*/, new Promise(function () { })];
                                        }
                                        globalContext.hasLogoutBeenCalled = true;
                                        document.addEventListener("visibilitychange", function () {
                                            if (document.visibilityState === "visible") {
                                                location.reload();
                                            }
                                        });
                                        postLogoutRedirectUrl = (function () {
                                            switch (params.redirectTo) {
                                                case "current page":
                                                    return window.location.href;
                                                case "home":
                                                    return homeAndCallbackUrl;
                                                case "specific url":
                                                    return (0, toFullyQualifiedUrl_1.toFullyQualifiedUrl)({
                                                        urlish: params.url,
                                                        doAssertNoQueryParams: false
                                                    });
                                            }
                                        })();
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 10]);
                                        return [4 /*yield*/, oidcClientTsUserManager.signoutRedirect({
                                                state: (0, tsafe_1.id)({
                                                    configId: configId,
                                                    context: "redirect",
                                                    redirectUrl: postLogoutRedirectUrl,
                                                    hasBeenProcessedByCallback: false,
                                                    action: "logout",
                                                    sessionId: sessionId
                                                }),
                                                redirectMethod: "assign"
                                            })];
                                    case 2:
                                        _b.sent();
                                        return [3 /*break*/, 10];
                                    case 3:
                                        error_4 = _b.sent();
                                        (0, tsafe_1.assert)((0, tsafe_1.is)(error_4));
                                        if (!(error_4.message === "No end session endpoint")) return [3 /*break*/, 8];
                                        log === null || log === void 0 ? void 0 : log("No end session endpoint, managing logging state locally");
                                        (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: "explicitly logged out" });
                                        _b.label = 4;
                                    case 4:
                                        _b.trys.push([4, 6, , 7]);
                                        return [4 /*yield*/, oidcClientTsUserManager.removeUser()];
                                    case 5:
                                        _b.sent();
                                        return [3 /*break*/, 7];
                                    case 6:
                                        _a = _b.sent();
                                        return [3 /*break*/, 7];
                                    case 7:
                                        window.location.href = postLogoutRedirectUrl;
                                        return [3 /*break*/, 9];
                                    case 8: throw error_4;
                                    case 9: return [3 /*break*/, 10];
                                    case 10: return [2 /*return*/, new Promise(function () { })];
                                }
                            });
                        }); }, renewTokens: (function () {
                            function renewTokens_nonMutexed(params) {
                                return __awaiter(this, void 0, void 0, function () {
                                    var extraTokenParams, result_loginSilent, oidcClientTsUser, _a, authResponse, authResponse_error, oidcClientTsUser_scope, error_5;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                extraTokenParams = params.extraTokenParams;
                                                log === null || log === void 0 ? void 0 : log("Renewing tokens");
                                                return [4 /*yield*/, (0, loginSilent_1.loginSilent)({
                                                        oidcClientTsUserManager: oidcClientTsUserManager,
                                                        stateQueryParamValue_instance: stateQueryParamValue_instance,
                                                        configId: configId,
                                                        getExtraTokenParams: function () { return extraTokenParams; }
                                                    })];
                                            case 1:
                                                result_loginSilent = _b.sent();
                                                if (result_loginSilent.outcome === "failure") {
                                                    throw new Error(result_loginSilent.cause);
                                                }
                                                _a = result_loginSilent.outcome;
                                                switch (_a) {
                                                    case "token refreshed using refresh token": return [3 /*break*/, 2];
                                                    case "got auth response from iframe": return [3 /*break*/, 3];
                                                }
                                                return [3 /*break*/, 10];
                                            case 2:
                                                {
                                                    log === null || log === void 0 ? void 0 : log("Refresh token used");
                                                    oidcClientTsUser = result_loginSilent.oidcClientTsUser;
                                                }
                                                return [3 /*break*/, 11];
                                            case 3:
                                                authResponse = result_loginSilent.authResponse;
                                                log === null || log === void 0 ? void 0 : log("Tokens refresh using iframe", authResponse);
                                                authResponse_error = authResponse["error"];
                                                oidcClientTsUser_scope = undefined;
                                                _b.label = 4;
                                            case 4:
                                                _b.trys.push([4, 6, , 7]);
                                                return [4 /*yield*/, oidcClientTsUserManager.signinRedirectCallback((0, loginSilent_1.authResponseToUrl)(authResponse))];
                                            case 5:
                                                oidcClientTsUser_scope =
                                                    _b.sent();
                                                return [3 /*break*/, 7];
                                            case 6:
                                                error_5 = _b.sent();
                                                (0, tsafe_1.assert)(error_5 instanceof Error);
                                                if (authResponse_error === undefined) {
                                                    throw error_5;
                                                }
                                                oidcClientTsUser_scope = undefined;
                                                return [3 /*break*/, 7];
                                            case 7:
                                                if (!(oidcClientTsUser_scope === undefined)) return [3 /*break*/, 9];
                                                (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: undefined });
                                                return [4 /*yield*/, loginOrGoToAuthServer({
                                                        action: "login",
                                                        redirectUrl: window.location.href,
                                                        doForceReloadOnBfCache: true,
                                                        extraQueryParams_local: undefined,
                                                        transformUrlBeforeRedirect_local: undefined,
                                                        doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack: false,
                                                        doForceInteraction: false
                                                    })];
                                            case 8:
                                                _b.sent();
                                                (0, tsafe_1.assert)(false);
                                                _b.label = 9;
                                            case 9:
                                                oidcClientTsUser = oidcClientTsUser_scope;
                                                return [3 /*break*/, 11];
                                            case 10:
                                                (0, tsafe_1.assert)(false);
                                                return [3 /*break*/, 11];
                                            case 11:
                                                currentTokens = (0, oidcClientTsUserToTokens_1.oidcClientTsUserToTokens)({
                                                    oidcClientTsUser: oidcClientTsUser,
                                                    decodedIdTokenSchema: decodedIdTokenSchema,
                                                    __unsafe_useIdTokenAsAccessToken: __unsafe_useIdTokenAsAccessToken,
                                                    decodedIdToken_previous: currentTokens.decodedIdToken,
                                                    log: log
                                                });
                                                Array.from(onTokenChanges).forEach(function (onTokenChange) { return onTokenChange(currentTokens); });
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                            var ongoingCall = undefined;
                            function handleFinally() {
                                (0, tsafe_1.assert)(ongoingCall !== undefined);
                                var pr = ongoingCall.pr;
                                pr.finally(function () {
                                    (0, tsafe_1.assert)(ongoingCall !== undefined);
                                    if (ongoingCall.pr !== pr) {
                                        return;
                                    }
                                    ongoingCall = undefined;
                                });
                            }
                            return function (params) { return __awaiter(_this, void 0, void 0, function () {
                                var extraTokenParams_local, extraTokenParams;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    extraTokenParams_local = (params !== null && params !== void 0 ? params : {}).extraTokenParams;
                                    extraTokenParams = __assign(__assign({}, getExtraTokenParams === null || getExtraTokenParams === void 0 ? void 0 : getExtraTokenParams()), extraTokenParams_local);
                                    if (ongoingCall === undefined) {
                                        ongoingCall = {
                                            pr: renewTokens_nonMutexed({ extraTokenParams: extraTokenParams }),
                                            extraTokenParams: extraTokenParams
                                        };
                                        handleFinally();
                                        return [2 /*return*/, ongoingCall.pr];
                                    }
                                    if (JSON.stringify(extraTokenParams) === JSON.stringify(ongoingCall.extraTokenParams)) {
                                        return [2 /*return*/, ongoingCall.pr];
                                    }
                                    ongoingCall = {
                                        pr: (function () { return __awaiter(_this, void 0, void 0, function () {
                                            var _a;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0:
                                                        _b.trys.push([0, 2, , 3]);
                                                        return [4 /*yield*/, ongoingCall.pr];
                                                    case 1:
                                                        _b.sent();
                                                        return [3 /*break*/, 3];
                                                    case 2:
                                                        _a = _b.sent();
                                                        return [3 /*break*/, 3];
                                                    case 3: return [2 /*return*/, renewTokens_nonMutexed({ extraTokenParams: extraTokenParams })];
                                                }
                                            });
                                        }); })(),
                                        extraTokenParams: extraTokenParams
                                    };
                                    handleFinally();
                                    return [2 /*return*/, ongoingCall.pr];
                                });
                            }); };
                        })(), subscribeToTokensChange: function (onTokenChange) {
                            onTokenChanges.add(onTokenChange);
                            return {
                                unsubscribe: function () {
                                    onTokenChanges.delete(onTokenChange);
                                }
                            };
                        }, subscribeToAutoLogoutCountdown: function (tickCallback) {
                            autoLogoutCountdownTickCallbacks.add(tickCallback);
                            var unsubscribeFromAutoLogoutCountdown = function () {
                                autoLogoutCountdownTickCallbacks.delete(tickCallback);
                            };
                            return { unsubscribeFromAutoLogoutCountdown: unsubscribeFromAutoLogoutCountdown };
                        }, goToAuthServer: function (_a) {
                            var extraQueryParams = _a.extraQueryParams, redirectUrl = _a.redirectUrl, transformUrlBeforeRedirect = _a.transformUrlBeforeRedirect;
                            return loginOrGoToAuthServer({
                                action: "go to auth server",
                                redirectUrl: redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : window.location.href,
                                extraQueryParams_local: extraQueryParams,
                                transformUrlBeforeRedirect_local: transformUrlBeforeRedirect
                            });
                        }, backFromAuthServer: resultOfLoginProcess.backFromAuthServer, isNewBrowserSession: (function () {
                            if (sessionStorage.getItem(BROWSER_SESSION_NOT_FIRST_INIT_KEY) === null) {
                                sessionStorage.setItem(BROWSER_SESSION_NOT_FIRST_INIT_KEY, "true");
                                log === null || log === void 0 ? void 0 : log("This is a new browser session");
                                return true;
                            }
                            log === null || log === void 0 ? void 0 : log("This is not a new browser session");
                            return false;
                        })() }));
                    sessionId = (0, decodeJwt_1.decodeJwt)(currentTokens.idToken).sid;
                    {
                        prOtherTabLogout = (0, logoutPropagationToOtherTabs_1.getPrOtherTabLogout)({
                            configId: configId,
                            homeUrl: homeAndCallbackUrl,
                            sessionId: sessionId
                        }).prOtherTabLogout;
                        prOtherTabLogout.then(function (_a) {
                            var redirectUrl = _a.redirectUrl;
                            log === null || log === void 0 ? void 0 : log("Other tab has logged out, redirecting to ".concat(redirectUrl));
                            window.location.href = redirectUrl;
                        });
                    }
                    (function scheduleRenew() {
                        var _this = this;
                        var login_dueToExpiration = function () {
                            (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: undefined });
                            return loginOrGoToAuthServer({
                                action: "login",
                                redirectUrl: window.location.href,
                                doForceReloadOnBfCache: true,
                                extraQueryParams_local: undefined,
                                transformUrlBeforeRedirect_local: undefined,
                                // NOTE: Wether or not it's the preferred behavior, pushing to history
                                // only works on user interaction so it have to be false
                                doNavigateBackToLastPublicUrlIfTheTheUserNavigateBack: false,
                                doForceInteraction: true
                            });
                        };
                        var msBeforeExpiration = (0, oidcClientTsUserToTokens_1.getMsBeforeExpiration)(currentTokens);
                        if (msBeforeExpiration <= MIN_RENEW_BEFORE_EXPIRE_MS) {
                            // NOTE: We just got a new token that is about to expire. This means that
                            // the refresh token has reached it's max SSO time.
                            login_dueToExpiration();
                            return;
                        }
                        // NOTE: We refresh the token 25 seconds before it expires.
                        // If the token expiration time is less than 25 seconds we refresh the token when
                        // only 1/10 of the token time is left.
                        var renewMsBeforeExpires = Math.max(Math.min(25000, msBeforeExpiration * 0.1), MIN_RENEW_BEFORE_EXPIRE_MS);
                        log === null || log === void 0 ? void 0 : log([
                            (0, toHumanReadableDuration_1.toHumanReadableDuration)(msBeforeExpiration),
                            "before expiration of the access token.",
                            "Scheduling renewal ".concat((0, toHumanReadableDuration_1.toHumanReadableDuration)(renewMsBeforeExpires), " before expiration")
                        ].join(" "));
                        var timer = (0, workerTimers_1.setTimeout)(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        log === null || log === void 0 ? void 0 : log("Renewing the access token now as it will expires in ".concat((0, toHumanReadableDuration_1.toHumanReadableDuration)(renewMsBeforeExpires)));
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, oidc_loggedIn.renewTokens()];
                                    case 2:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        _a = _b.sent();
                                        return [4 /*yield*/, login_dueToExpiration()];
                                    case 4:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); }, msBeforeExpiration - renewMsBeforeExpires);
                        var tokenChangeUnsubscribe = oidc_loggedIn.subscribeToTokensChange(function () {
                            (0, workerTimers_1.clearTimeout)(timer);
                            tokenChangeUnsubscribe();
                            scheduleRenew();
                        }).unsubscribe;
                    })();
                    auto_logout: {
                        if (currentTokens.refreshToken === "" && __unsafe_ssoSessionIdleSeconds === undefined) {
                            log === null || log === void 0 ? void 0 : log("No refresh token, and ____unsafe_ssoSessionIdleSeconds was not set, auto logout non applicable");
                            break auto_logout;
                        }
                        startCountdown_2 = (0, startCountdown_1.createStartCountdown)({
                            getCountdownEndTime: (function () {
                                var getCountdownEndTime = function () {
                                    return __unsafe_ssoSessionIdleSeconds !== undefined
                                        ? Date.now() + __unsafe_ssoSessionIdleSeconds * 1000
                                        : currentTokens.refreshTokenExpirationTime;
                                };
                                var durationBeforeAutoLogout = (0, toHumanReadableDuration_1.toHumanReadableDuration)(getCountdownEndTime() - Date.now());
                                log === null || log === void 0 ? void 0 : log([
                                    "The user will be automatically logged out after ".concat(durationBeforeAutoLogout, " of inactivity."),
                                    __unsafe_ssoSessionIdleSeconds === undefined
                                        ? undefined
                                        : "It was artificially defined by using the __unsafe_ssoSessionIdleSeconds param."
                                ]
                                    .filter(function (x) { return x !== undefined; })
                                    .join("\n"));
                                return getCountdownEndTime;
                            })(),
                            tickCallback: function (_a) {
                                var secondsLeft = _a.secondsLeft;
                                Array.from(autoLogoutCountdownTickCallbacks).forEach(function (tickCallback) {
                                    return tickCallback({ secondsLeft: secondsLeft });
                                });
                                if (secondsLeft === 0) {
                                    oidc_loggedIn.logout(autoLogoutParams);
                                }
                            }
                        }).startCountdown;
                        stopCountdown_1 = undefined;
                        if (globalContext.$isUserActive === undefined) {
                            globalContext.$isUserActive = (0, isUserActive_1.create$isUserActive)({
                                configId: configId,
                                sessionId: sessionId
                            });
                        }
                        globalContext.$isUserActive.subscribe(function (isUserActive) {
                            if (isUserActive) {
                                if (stopCountdown_1 !== undefined) {
                                    stopCountdown_1();
                                    stopCountdown_1 = undefined;
                                }
                            }
                            else {
                                (0, tsafe_1.assert)(stopCountdown_1 === undefined);
                                stopCountdown_1 = startCountdown_2().stopCountdown;
                            }
                        });
                    }
                    {
                        if ((0, persistedAuthState_1.getPersistedAuthState)({ configId: configId }) !== undefined) {
                            (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: undefined });
                        }
                        if (!areThirdPartyCookiesAllowed) {
                            (0, persistedAuthState_1.persistAuthState)({ configId: configId, state: "logged in" });
                        }
                    }
                    toCallBeforeReturningOidcLoggedIn();
                    return [2 /*return*/, oidc_loggedIn];
            }
        });
    });
}
//# sourceMappingURL=createOidc.js.map